<template>
  <v-menu
    offset-y
    left
  >
    <template #activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        class="mr-5"
        v-on="on"
      >
        {{ icons.mdiViewGridPlusOutline }}
      </v-icon>
    </template>
    <v-card>
      <v-card-title>Acciones</v-card-title>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-btn
              color="primary"
              outlined
              @click="runCronJob"
            >
              <v-icon>{{ icons.mdiCalendarRefresh }}</v-icon>
              Sync Calendly
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import {
  mdiViewGridPlusOutline, mdiCalendarRefresh,
} from '@mdi/js'

import store from '@/store'

export default {
  components: {
  },
  setup() {
    const runCronJob = () => {
      store.dispatch('cronJob/apiCall', { mode: 'Select', request: { token: 'EF112C55BA2248E196646844C49F755B-1' } }).then(result => {
        if (result.success) {
          store.dispatch('cronJob/apiCall', { mode: 'Select', request: { token: 'EF112C55BA2248E196646844C49F755B-2' } }).then(() => {
          })
        }
      })
    }

    return {
      runCronJob,
      icons: {
        mdiViewGridPlusOutline, mdiCalendarRefresh,
      },
    }
  },
}
</script>
